import { FC } from "react";

import Box from "@mui/material/Box";
import Grow from "@mui/material/Grow";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardInfobox } from "@/dashboard-design-system/Infobox";
import { CheckInTooltipPlacement } from "@/features/LiveFormEditor/LivePreview/ETicketLivePreview/helpers/checkInTooltip";
import { Scan } from "@/icons/outlined";

export interface CheckInTooltipProps {
  placement: CheckInTooltipPlacement;
  onClose: () => void;
  onMoreAboutCheckInClick: () => void;
}

export const CheckInTooltip: FC<CheckInTooltipProps> = ({ placement, onClose, onMoreAboutCheckInClick }) => {
  const { t } = useTranslate();

  return (
    <Grow in appear style={{ transformOrigin: getTransformOrigin(placement.pointer) }}>
      <Box
        data-test="check-in-tooltip"
        sx={{ position: "absolute", top: placement.top, left: placement.left, width: placement.width, zIndex: 1 }}
      >
        <DashboardInfobox
          vibe="positive"
          size="medium"
          pointer={placement.pointer}
          icon={<Scan />}
          onClose={onClose}
          buttonsProps={[
            {
              key: "more-about-check-in",
              children: t("dashboard", "ticketing.setETicket.checkInTooltip.moreAboutCheckIn"),
              onClick: onMoreAboutCheckInClick,
              variant: "tonal",
              "data-test": "check-in-tooltip-more-button",
            },
          ]}
          sx={(theme) => ({ boxShadow: theme.boxShadow.base.strong })}
        >
          {t("dashboard", "ticketing.setETicket.checkInTooltip.description")}
        </DashboardInfobox>
      </Box>
    </Grow>
  );
};

const getTransformOrigin = (pointer: CheckInTooltipPlacement["pointer"]) => {
  if (pointer === "top-left") {
    return "left top";
  }
  if (pointer === "top-right") {
    return "right top";
  }
  return "center top";
};
